import React, { useState, useCallback, useEffect, useRef } from "react";
import { connect } from "react-redux";
import AccordionReact from 'devextreme-react/accordion';
import FormField from '../../../../../../dynamicFormBuilder/FormField';
import CustomerSearchFormLayout from './CustomerSearchFormLayout';
import {
    GetLookupData
} from "../../../../../../om/services/SalesOrderService";
import Toolbar, { Item } from "devextreme-react/toolbar";
import { Button } from 'devextreme-react/button';
const searchpanel = [
    {
        ID: 1,
        Title: 'Search Filters'
    }
];
const CustomerSearchForm = (props) => {
    const arOpenItemsTab = 2;
    const getProfileUrl = "om/SaleOrder/GetProfiles";
    const getCustomerUrl = "om/SaleOrder/GetCustomers";
    const [selectedItems, setSelectedItems] = useState([]);
    var accessToken = props.oidc.user.access_token;
    var currentUser = props.oidc.user;
    const [forceRender, setForceRender] = useState(false);
    const DYNAMICFORMSETTING = props.oidc?.user?.profile?.DYNAMICFORMSETTING;
    const initialFormFields = {
        R_CUSTOMER: '',
        Name: '',
        Address1: '',
        Address2: '',
        City: '',
        State: '',
        Zip: '',
        Tel: '',

    };
    const [formFields, setformFields] = useState(initialFormFields);

    const selectionChanged = useCallback(
        (e) => {
            let newItems = [...selectedItems];
            e.removedItems.forEach((item) => {
                const index = newItems.indexOf(item);
                if (index >= 0) {
                    newItems.splice(index, 1);
                }
            });
            if (e.addedItems.length) {
                newItems = [...newItems, ...e.addedItems];
            }
            setSelectedItems(newItems);
        },
        [selectedItems, setSelectedItems],
    );
    const handleFormSubmit = (e) => {
        e.preventDefault();
        props.searchData(formFields);
    };
    const handleFieldChange = useCallback((name, value) => {
        console.log(name, value)

    }, []);
    const handleReset = (e) => {
        e.event.stopPropagation()
        setformFields(initialFormFields);
    };
    const formRefs = useRef({});
    const handleSalesOrderSearchFormLoad = useCallback(() => {
        GetLookupData("R_PROFILE", getProfileUrl, accessToken, formRefs, formRefs, setForceRender, forceRender);
        GetLookupData("R_CUSTOMER", getCustomerUrl, accessToken, formRefs, formRefs, setForceRender, forceRender);
    }, []);

    return (
        <form onSubmit={(e) => handleFormSubmit(e)}>
            <AccordionReact
                dataSource={searchpanel}
                collapsible={true}
                multiple={false}
                animationDuration={300}
                selectedItems={selectedItems}
                onSelectionChanged={e => {
                    if (e.currentTarget === e.target) {
                        selectionChanged(e, e.target);
                    }
                }}
                itemTitleRender={() => (
                    <Toolbar className="accordian-toolbar">
                        <Item location="before">
                            <div className="title">
                                <h6
                                    style={{
                                        color: window._env_.Color2
                                    }}
                                >
                                    Customers
                                </h6>
                            </div>
                        </Item>

                        <Item location="after">
                            <Button className="accordianButton" useSubmitBehavior={true} onClick={(e)=>e.event.stopPropagation()} text="Search" type="default" />
                        </Item>
                        <Item location="after">
                            <Button className="accordianButton" onClick={handleReset} text="Reset" />
                        </Item>
                    </Toolbar>
                )}
                itemRender={() => (
                    <div>
                        <FormField
                            currrentUser={currentUser}
                            layoutId='E4775B5D-9133-4DDB-8300-058CE6AC092E'
                            layoutName='MyTestForm'
                            defaultFormSchema={CustomerSearchFormLayout}
                            formFields={formFields}
                            setformFields={setformFields}
                            handleFieldValueChange={handleFieldChange}
                            DYNAMICFORMSETTING={DYNAMICFORMSETTING}
                            formRefs={formRefs}
                            onFormLoad={handleSalesOrderSearchFormLoad}
                            noSpacingBeforeFirstRow={true}
                        />

                    </div>
                )}
                id="accordion-container" className="accordion-height"
            />
        </form>

    );
};
function mapStateToProps(state) {
    return {
        ReceiptReducer: state.ReceiptReducer,
        oidc: state.oidc,
    };
}
export default connect(mapStateToProps)(CustomerSearchForm);